import { useQuery } from '@tanstack/react-query';

import { getSearchProjectSubcontractSelectOptions } from './projectSubcontracts';
import { TypesenseCollection } from '../types';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const PROJECT_SUBCONTRACTS_OPTION_KEY = 'projectSubcontractOption';
export const useGetProjectSubcontractOptionsByProjectId = (
  projectId: number | string | undefined,
) => {
  const _projectId =
    projectId && typeof projectId === 'string'
      ? projectId
      : (projectId?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECT_SUBCONTRACTS.keyName]?.key ?? null;

  const { data, ...restProps } = useQuery({
    queryKey: [
      PROJECT_SUBCONTRACTS_OPTION_KEY,
      'by_project_id',
      _projectId,
      collectionApiKey,
    ],
    queryFn: () =>
      getSearchProjectSubcontractSelectOptions('*', collectionApiKey!, 1, {
        filterBy: `ProjectId:=${_projectId}`,
      }),
    enabled: !!_projectId && !!collectionApiKey,
  });

  return { data, ...restProps };
};
